<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back" />
			<img src="@/images/center_text15.png" class="per_right_1name" />
		</div>
		<div class="per_right_2">
			<div class="app_right_bottom">
				<div v-if="!myEvalute || myEvalute.length<=0" class="simulation_empty_msg_content">暂无教师评价</div>
				<div v-for="it in myEvalute" class="myEvaluteItem">
					<span class="myEvaluteTeacher">{{it.templateName}} | </span><span class="myEvaluteTeacher">评价教师：{{it.createUserName}}</span>
					<div class="workview-rightitem" v-for="(item,index) in it.qusetionlist">
						<div class="work-question">
							{{index+1+'、'}}
							<el-tag type='primary' size='medium'>{{item.type=='1'?'主观项':'评分项'}}</el-tag>
							<span class="work-questioninfo">{{item.name}}</span>
						</div>
						<div class="work-answer">
							{{item.type =='1'?"评语":"得分"}}：{{item.defaultScore}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { selectOurStudentEvaluate } from '@/api/user.js'
	export default {
		data() {
			return {
				myEvalute: [],
				qusetionlist: [],
			}
		},
		created() {
			this.getMyEvalute()
		},
		methods: {
			getMyEvalute() {
				selectOurStudentEvaluate().then(res => {
					if(res.code == '0' && res.data) {
						var myEvalute = res.data;
						myEvalute.map(iteminfo => {
							var qusetionlist = [];
							iteminfo.tscoreDetailsDOS.map(item => {
								if(item.type == '0') {
									item.defaultScore = item.defaultScore * 1;
								}
								qusetionlist.push(item);
							})
							iteminfo.qusetionlist = qusetionlist;
						})
						this.myEvalute = myEvalute;
					}
				})
			},
		},
	};
</script>

<style>

</style>